import React, { useEffect } from 'react';
import { Link, useLocation } from "react-router";
import '../styles/NotFoundPage.css';

const NotFoundPage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = 'Page not found | Atlanta Executive Property Management';
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex';
    document.head.appendChild(robots);
    return () => {
      document.head.removeChild(robots);
    };
  }, []);

  return (
    <main className="error-page">
      <div className="error-inner">
        <span className="error-num">404</span>
        <h1>Page not found</h1>
        <p>
          We couldn't find <code>{location.pathname}</code>. The link may be
          out of date, or the page has moved.
        </p>
        <div className="error-cta">
          <Link to="/" className="primary">&larr; Back to home</Link>
          <Link to="/contact" className="secondary">Contact us</Link>
          <Link to="/request-a-proposal" className="secondary">Request a proposal</Link>
        </div>
        <div className="error-jump">
          Or jump to one of our pages:
          <div className="error-jump-links">
            <Link to="/services">Services</Link>
            <Link to="/about-us">About</Link>
            <Link to="/rental">Rental</Link>
            <Link to="/home-wise-docs">Owner Docs</Link>
          </div>
        </div>
      </div>
    </main>
  );
};

export default NotFoundPage;
